import * as React from "react";
import { PeopleTeam28Filled, PeopleTeam28Regular } from "@fluentui/react-icons";
import { TeamAppConfig } from "Apps/TeamAppModel";
import { ON_CALL_LOAD_BALANCER_DESCRIPTION, ON_CALL_LOAD_BALANCER_ROUTE, ON_CALL_LOAD_BALANCER_TITLE } from "./OnCallLoadBalancer.constants";

const OnCallLoadBalancerApp = React.lazy(async () => {
    const namedExport = await import(/* webpackChunkName: "OnCallLoadBalancer" */ "./OnCallLoadBalancerApp");
    return { default: namedExport.OnCallLoadBalancerApp };
});

export const OnCallLoadBalancer: TeamAppConfig = {
    title: ON_CALL_LOAD_BALANCER_TITLE,
    regularIcon: PeopleTeam28Regular,
    filledIcon: PeopleTeam28Filled,
    description: ON_CALL_LOAD_BALANCER_DESCRIPTION,
    team: "OSP",
    publicId: "Exchange\\OSP",
    owner: "OspOncall@microsoft.com",
    role: "*",
    tags: ["on-call", "incidents", "live-site"],
    app: OnCallLoadBalancerApp,
    path: ON_CALL_LOAD_BALANCER_ROUTE
};
